import OffersGrid from './offers-grid';
export default OffersGrid;